/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import {
  set, forEach, get, remove, map, find,
} from 'lodash';
import {
  FETCH_COIN_SETTING_SUCCEED,
  FETCH_MARKET,
  FETCH_MARKET_SUCCEED,
  FETCH_MARKET_FAILED,
  FETCH_ALL_COIN_SUCCEED,
  FETCH_LIMIT_WITHDRAWAL_SUCCEED, WS_EVENT_LAST_PRICE_UPDATED,
} from '../actions/setting_data/action_types';
import {
  FETCH_FAVORITES_SUCCEED,
  LOCAL_FETCH_FAVORITES,
  LOCAL_FETCH_DELETE_FAVORITES,
  LOCAL_FETCH_UPDATE_FAVORITES,
} from '../actions/favorites/action_types';

export default (state = {
  coinSettings: [],
  currencyMarkets: {},
  mapCurrencyMarkets: {},
  coins: [],
  limitWithdrawals: [],
  isTableLoading: false,
  favorites: [],
}, action) => {
  const myFavorites = [];
  const localFavorites = JSON.parse(window.localStorage.getItem('favorites') || '[]');
  let coin = '';
  let currency = '';

  switch (action.type) {
    case FETCH_COIN_SETTING_SUCCEED:
      window._.forEach(action.params.data, (item) => {
        item.pair = `${item.coin}/${item.currency}`;
      });
      return {
        ...state,
        coinSettings: action.params.data,
      };

    case FETCH_ALL_COIN_SUCCEED:
      const coins = window._.reduce(action.params.data, (result, item) => {
        result[item.coin] = item;
        return result;
      }, {});

      return {
        ...state,
        coins,
      };

    case FETCH_MARKET:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_MARKET_SUCCEED:
      const mapCurrencyMarkets = {};
      const currencyMarkets = window._.reduce(action.params.data, (result, item, market) => {
        const pair = `${market}`.split(':');
        const coin = pair[0];
        const currency = pair[1];
        result.all = window._.values(action.params.data);

        if (window._.isEmpty(result[currency])) {
          result[currency] = [];
        }

        item.coin = coin;
        item.currency = currency;
        item.isChecked = false;

        if (!window.$isAuthenticated) {
          forEach(localFavorites, (value, key) => {
            if (item.currency === value.currency && item.coin === value.coin) {
              item.isChecked = value.isChecked;
            }
          });
        }
        result[currency].push(item);
        set(mapCurrencyMarkets, `${currency}.${coin}`, item);
        return result;
      }, {});
      return {
        ...state,
        currencyMarkets,
        mapCurrencyMarkets,
        isTableLoading: false,
      };
    case FETCH_MARKET_FAILED:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_LIMIT_WITHDRAWAL_SUCCEED:
      return {
        ...state,
        limitWithdrawals: window._.keyBy(action.params.data, ({ currency, security_level }) => `${currency}:${security_level}`),
      };
    case WS_EVENT_LAST_PRICE_UPDATED:
      const { data, options } = action;
      const currencyMarket = state.currencyMarkets[options.currency] || [];
      for (let i = 0; i < currencyMarket.length; i++) {
        if (currencyMarket[i].coin === options.coin) {
          const title = `${options.coin}/${options.currency} ${data.last_price} - ${data.volume} Bitcoin Exchange | Cryptocurrency Exchange | TrustKeys Network`;
          data.coin = options.coin;
          data.currency = options.currency;
          if (data.last_price >= currencyMarket[i].last_price) {
            data.style = {
              color: 'green',
            };
          } else {
            data.style = {
              color: 'red',
            };
          }
          currencyMarket[i] = { ...currencyMarket[i], ...data };

          document.querySelector('#meta_title').innerHTML = title;
          document.querySelector('#title').innerHTML = title;
          break;
        }
      }

      return {
        ...state,
        currencyMarkets: { ...state.currencyMarkets },
        // favorites: myFavorites,
      };
    case FETCH_FAVORITES_SUCCEED:
      // favorites array
      const favorites = action.data;
      // currencyMarkets array
      forEach(favorites, (favorite) => {
        const cMarket = get(state.mapCurrencyMarkets, [favorite.currency, favorite.coin], {});
        cMarket.isChecked = true;
        favorite.isChecked = true;
        myFavorites.push(cMarket);
      });

      return {
        ...state,
        favorites: myFavorites,
      };

    case LOCAL_FETCH_FAVORITES:
      return {
        ...state,
        favorites: localFavorites,
      };

    case LOCAL_FETCH_UPDATE_FAVORITES:
      coin = action.params.coin || '';
      currency = action.params.currency || '';
      localFavorites.push(action.params);
      window.localStorage.setItem('favorites', JSON.stringify(localFavorites));
      state.mapCurrencyMarkets[currency][coin].isChecked = true;

      return {
        ...state,
        favorites: localFavorites,
      };

    case LOCAL_FETCH_DELETE_FAVORITES:
      coin = action.params.coin || '';
      currency = action.params.currency || '';
      remove(localFavorites, (value) => value.coin === coin && value.currency === currency);
      window.localStorage.setItem('favorites', JSON.stringify(localFavorites));
      state.mapCurrencyMarkets[currency][coin].isChecked = false;

      return {
        ...state,
        favorites: localFavorites,
      };

    default:
      return {
        ...state,
      };
  }
};
